// FuelCostCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
const TITLE = "Kalkulator Konsumsi Bahan Bakar - Hitung Konsumsi Bensin";
const DESCRIPTION =
  "Kalkulator biaya bahan bakar membantu Anda menghitung jumlah bahan bakar yang dibutuhkan dan memperkirakan biayanya secara akurat berdasarkan jarak yang akan Anda tempuh, efisiensi konsumsi bahan bakar, dan harga bahan bakar saat ini. Gunakan alat ini untuk merencanakan anggaran perjalanan Anda berikutnya dengan mudah.";
const KEYWORDS =
  "kalkulator biaya bahan bakar, biaya bahan bakar, jumlah bahan bakar yang dibutuhkan, efisiensi bahan bakar, harga bahan bakar, perencanaan perjalanan";
const OG_URL = "https://do-calculate.com/calculator/id/fuel-cost-calculator";
function FuelCostCalculator() {
  const [distance, setDistance] = useState("");
  const [fuelEfficiency, setFuelEfficiency] = useState("");
  const [fuelPrice, setFuelPrice] = useState("");
  const [unitDistance, setUnitDistance] = useState("miles");
  const [unitEfficiency, setUnitEfficiency] = useState("mpg");
  const [unitPrice, setUnitPrice] = useState("per gallon");
  const [result, setResult] = useState("");
  const [error, setError] = useState("");
  const calculateFuelCost = () => {
    if (!distance || !fuelEfficiency || !fuelPrice) {
      setError("Harap masukkan semua nilai dengan benar");
      setResult("");
      return;
    }
    let distanceInMiles = parseFloat(distance);
    let efficiencyInMpg = parseFloat(fuelEfficiency);
    let pricePerGallon = parseFloat(fuelPrice);
    if (unitDistance === "km") {
      distanceInMiles = distanceInMiles * 0.621371;
    }
    if (unitEfficiency === "liters per 100 km") {
      efficiencyInMpg = 235.214583 / efficiencyInMpg;
    } else if (unitEfficiency === "kilometers per liter") {
      efficiencyInMpg = efficiencyInMpg * 2.35214583;
    } else if (unitEfficiency === "liter per mile") {
      efficiencyInMpg = 1 / (efficiencyInMpg * 0.264172);
    }
    if (unitPrice === "per liter") {
      pricePerGallon = pricePerGallon * 3.78541;
    }
    const gallonsRequired = distanceInMiles / efficiencyInMpg;
    const cost = gallonsRequired * pricePerGallon;
    setResult({
      gallonsRequired: gallonsRequired.toFixed(2),
      cost: cost.toFixed(2),
    });
    setError("");
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Selamat datang di Kalkulator Biaya Bahan Bakar! Alat luar biasa ini membantu Anda menghitung jumlah bahan bakar yang dibutuhkan dan biayanya secara akurat untuk berbagai perjalanan. Baik Anda merencanakan perjalanan jauh melintasi negara atau hanya perjalanan singkat, Kalkulator Biaya Bahan Bakar memberikan informasi yang Anda butuhkan untuk merencanakan anggaran secara efektif. Dengan alat ini, Anda dapat dengan mudah mengetahui total biaya bahan bakar berdasarkan jarak, efisiensi konsumsi bahan bakar, dan harga bahan bakar saat ini.
                </p>
                <p>Untuk menggunakan kalkulator secara efektif:</p>
                <ul>
                  <li>
                    Masukkan jarak yang akan Anda tempuh, efisiensi konsumsi bahan bakar (km/liter), dan harga bahan bakar per unit.
                  </li>
                  <li>Pilih unit yang sesuai untuk setiap nilai untuk memastikan akurasi perhitungan.</li>
                  <li>
                    Tekan tombol "Hitung Biaya" untuk mendapatkan estimasi akurat biaya bahan bakar yang dibutuhkan.
                  </li>
                  <li>
                    Hasil akan muncul di bawah formulir, memudahkan Anda merencanakan perjalanan.
                  </li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div >
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label className="form-label ms-2">Jarak Perjalanan</label>
                    </b>
                    <input
                      type="number"
                      value={distance}
                      onChange={(e) => setDistance(e.target.value)}
                      className="form-control"
                      placeholder="Masukkan jarak"
                      style={{ width: "75%", marginRight: "10px" }}
                    />
                    <select
                      value={unitDistance}
                      onChange={(e) => setUnitDistance(e.target.value)}
                      className="form-select"
                      style={{ width: "90%" }}
                    >
                      <option value="miles">Mil</option>
                      <option value="km">Km</option>
                    </select>
                  </div>
                  <div className="form-group d-flex align-items-center mt-2">
                    <b>
                      <label className="form-label ms-2">Efisiensi Bahan Bakar</label>
                    </b>
                    <input
                      type="number"
                      value={fuelEfficiency}
                      onChange={(e) => setFuelEfficiency(e.target.value)}
                      className="form-control"
                      placeholder="Masukkan efisiensi"
                      style={{ width: "75%", marginRight: "10px" }}
                    />
                    <select
                      value={unitEfficiency}
                      onChange={(e) => setUnitEfficiency(e.target.value)}
                      className="form-select"
                      style={{ width: "90%" }}
                    >
                      <option value="mpg">Mil per galon</option>
                      <option value="liters per 100 km">Liter per 100 km</option>
                      <option value="kilometers per liter">Km per liter</option>
                      <option value="liter per mile">Liter per mil</option>
                    </select>
                  </div>
                  <div className="form-group d-flex align-items-center mt-2">
                    <b>
                      <label className="form-label ms-2">Harga Bahan Bakar</label>
                    </b>
                    <input
                      type="number"
                      value={fuelPrice}
                      onChange={(e) => setFuelPrice(e.target.value)}
                      className="form-control"
                      placeholder="Masukkan harga"
                      style={{ width: "75%", marginRight: "10px" }}
                    />
                    <select
                      value={unitPrice}
                      onChange={(e) => setUnitPrice(e.target.value)}
                      className="form-select"
                      style={{ width: "90%" }}
                    >
                      <option value="per gallon">Per galon</option>
                      <option value="per liter">Per liter</option>
                    </select>
                  </div>
                  <br />
                  <p className="alert alert-info">
                    <b>Efisiensi Bahan Bakar: </b>
                    adalah jumlah kilometer yang dapat ditempuh mobil Anda dengan satu liter bahan bakar. Anda dapat menemukannya di manual mobil, di dashboard, atau menghitungnya sendiri.
                  </p>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateFuelCost}
                  >
                    Hitung
                  </button>
                </div>
                <br />
                <div>
                  { error !== "" ? (
                    <p className="p-3 mb-2 bg-warning text-white">
                      Error: {error}
                    </p>
                  ) : (
                    <>
                      { result && (
                        <>
                          <p className="p-3 mb-2 bg-success text-white">
                            Biaya Perjalanan:
                          </p>
                          <p className="p-3 mb-2 bg-info text-black">
                            {result.gallonsRequired} galon bahan bakar
                          </p>
                          <p className="p-3 mb-2 bg-info text-black">
                            {result.cost} dolar
                          </p>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                Faktor-faktor yang Mempengaruhi Konsumsi Bahan Bakar
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                Ada banyak faktor yang dapat mempengaruhi konsumsi bahan bakar, termasuk:
              </p>
              <ul>
                <li>Jenis kendaraan</li>
                <li>Kecepatan mengemudi</li>
                <li>Kondisi jalan</li>
                <li>Tekanan ban</li>
                <li>Kondisi mesin</li>
              </ul>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>Menghemat Bahan Bakar</h3>
            </div>
            <div className="info-section-body">
              <p>Ada banyak cara untuk menghemat bahan bakar, termasuk:</p>
              <ul>
                <li>Berkendara hemat</li>
                <li>Memantau tekanan ban</li>
                <li>Menjaga kendaraan dalam kondisi baik</li>
                <li>Memilih bahan bakar yang tepat</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default FuelCostCalculator;